export default __webpack_public_path__ + "static/quadrant-text-regular-italic-1f034dbbfe4acd5a06683661d52c64f7.ttf";